<script lang="ts">
    import VariantTiles from "$components/Sections/VariantTiles.svelte";
    import FeaturesThreeColumns from "$components/Sections/FeaturesThreeColumns.svelte";
    import StatsStepped from "$components/Sections/StatsStepped.svelte";
    import HeroSimpleCentered from "$components/Sections/HeroSimpleCentered.svelte";
    import VariantSplit from "$components/Sections/VariantSplit.svelte";
    import CardsWithBigImages from "$components/Sections/CardsWithBigImages.svelte";
    import Comparison from "./Comparison.svelte";
    import Team from "./Team.svelte";
    import Faq from "./Faq.svelte";
    import FeatureWithOffset from "./FeatureWithOffset.svelte";
    import MarkdownText from "./MarkdownText.svelte";
    import Contact from "$components/Sections/Contact.svelte";
    import ContactForm from "$components/Elements/ContactForm.svelte";
    import Map from "$components/Sections/Map.svelte";
    import FormVariant from "$components/Sections/FormVariant.svelte";
    import Stores from "$components/Sections/Stores.svelte";

    export let sections: Section[];
</script>


{#if sections.length > 0}
    {#each sections as section, index}
        {#if section.__component === 'sections.hero-tiles'}
            <VariantTiles {section} {index} />
        {:else if section.__component === 'sections.hero-split-with-image'}
            <VariantSplit {section} {index} />
        {:else if section.__component === 'sections.features-three-columns'}
            <FeaturesThreeColumns {section} {index} />
        {:else if section.__component === 'sections.features-stats'}
            <StatsStepped {section} {index} />
        {:else if section.__component === 'sections.hero-simple'}
            <HeroSimpleCentered {section} {index} />
        {:else if section.__component === 'sections.cards-with-big-images'}
            <CardsWithBigImages {section} {index} />
        {:else if section.__component === 'sections.comparison'}
            <Comparison {section} {index} />
        {:else if section.__component === 'sections.team'}
            <Team {section} {index} />
        {:else if section.__component === 'sections.faq'}
            <Faq {section} {index} />
        {:else if section.__component === 'sections.feature-with-offset'}
            <FeatureWithOffset {section} {index} />
        {:else if section.__component === 'sections.formatted-text'}
            <MarkdownText {section} {index} />
        {:else if section.__component === 'sections.contact-form'}
            <FormVariant {section} {index} />
        {:else if section.__component === 'sections.map'}
            <Map {section} {index} />
        {:else if section.__component === 'sections.stores'}
            <Stores {section} {index} />
        {/if}
    {/each}
{/if}
